import { css } from '@emotion/react';

import { colors } from '../../../../styles/colors';
import { ZeeFontBold, ZeeFontRegular } from '../../../../styles/font';
import { MediaBP as MQ } from '../../../../styles/mediaQuery';
export const container = css`
  z-index: 0;
  height: 100%;
  border-radius: 8px;
  &:hover {
    z-index: 10;
  }
`;
export const contentItemPopUp = css`
  position: absolute;
  bottom: 0;
  padding: 10px 1px 5px 4px;
  background-color: ${colors.white};
  width: 100%;
  color: ${colors.black};
  opacity: 0;
  filter: blur(20px);
  text-align: left;
  transform: scale3d(0.01, 0.01, 0) translateZ(0) perspective(500px);
  transition: opacity 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), transform 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93), filter 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
    background-color 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93),
    border-radius 0.25s ease-in,
    bottom 0.25s cubic-bezier(0.33, 0.04, 0.63, 0.93);
  & h3 {
    font-size: 10px;
    font-weight: 700;
    line-height: 1.4em;
    ${ZeeFontBold(10, 20)}
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    color: ${colors.AccentDarkGrayColor};
  }
`;

export const thumbnailTitleWrapper = css`
  ${ZeeFontRegular(12)};
  display: -webkit-box;
  display: box;
  max-height: 48px;
  white-space: wrap;
  -webkit-line-clamp: 2;
  /* autoprefixer: off */
  -webkit-box-orient: vertical;
  /* autoprefixer: on */
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${colors.PrimaryWhiteColor};
  ${MQ.MediaMd} {
    ${ZeeFontRegular(16, 18)};
  }
`;
export const thumbnailTitleDate = css`
  color: ${colors.white};
`;
export const thumbnailTitle = css`
  color: ${colors.PrimaryWhiteColor};
`;
export const plexCardMetaContainer = css`
  background: linear-gradient(
    270deg,
    #170e40 22.3%,
    #3b1c81 64.31%,
    #49104a 100%
  );
  border-radius: 0 0 6px 6px;
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  padding: 8px 8px 7px 0;
  ${MQ.MediaMd} {
    padding: 16px 13px 12px 0;
  }
`;

export const plexCardMetaDetail = css`
  text-align: left;
  ${ZeeFontRegular(12)};
  padding-left: 8px;
  ${MQ.MediaMd} {
    padding-left: 15px;
  }
`;
